export function includeRule(newstate, state, rule) {
    var attrLast = []
    if (state.hasOwnProperty('options_' + rule))
        attrLast = state['options_' + rule]
    if (newstate.hasOwnProperty('options_' + rule))
        attrLast = newstate['options_' + rule]
    for (let j in attrLast.options) {
        attrLast.options[j].show = true
    }
    return attrLast
}
  
export function excludeRule(newstate, state, rule, allstate) {
    var condition = true
    var attr = []
    for (let i in rule) {
        if (i < rule.length - 1) {
            var attr1 = '?'
            if (state.hasOwnProperty(rule[i][0]))
                attr1 = state[rule[i][0]]
            if (newstate.hasOwnProperty(rule[i][0]))
                attr1 = newstate[rule[i][0]]
            attr.push(attr1)
            if (rule[i][1].includes(attr1) !== true)
                condition = false
        }
    }

    var last = rule.length - 1
    var attrLast = allstate
    if (attrLast !== undefined && condition) {
        for (let j in attrLast.options) {
            if (rule[last][1].includes(attrLast.options[j].value)) {
                attrLast.options[j].show = false
            }
        }
        return attrLast
    }
    return attrLast
}

export function check_default(newrule) {
    var first_val = '?'
    for (let i in newrule.options) {
        if (newrule.options[i].show === true) {
            first_val = newrule.options[i].value
            break
        }
    }
    return first_val
}

export function check_default_max(newrule) {
    var arr = newrule.options.slice().reverse()
    var last_val = '?'
    for (let i in arr) {
        if (arr[i].show === true) {
            last_val = arr[i].value
            break
        }
    }
    return last_val
}


// WEBPACK FOOTER //
// ./src/reducers/rules_functions.js